var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.667 5a1.667 1.667 0 011.666-1.667h13.334A1.666 1.666 0 0118.333 5v10a1.667 1.667 0 01-1.666 1.667H3.333A1.667 1.667 0 011.667 15V5z",
    stroke: "#009BBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.667 6.667l6.25 5a3.333 3.333 0 004.165 0l6.251-5",
    stroke: "#009BBF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNjY2NjMgNS4wMDAwNEMxLjY2NjYzIDQuNTU4MDEgMS44NDIyMiA0LjEzNDA5IDIuMTU0NzggMy44MjE1M0MyLjQ2NzM0IDMuNTA4OTcgMi44OTEyNyAzLjMzMzM3IDMuMzMzMjkgMy4zMzMzN0gxNi42NjY2QzE3LjEwODcgMy4zMzMzNyAxNy41MzI2IDMuNTA4OTcgMTcuODQ1MSAzLjgyMTUzQzE4LjE1NzcgNC4xMzQwOSAxOC4zMzMzIDQuNTU4MDEgMTguMzMzMyA1LjAwMDA0VjE1QzE4LjMzMzMgMTUuNDQyMSAxOC4xNTc3IDE1Ljg2NiAxNy44NDUxIDE2LjE3ODZDMTcuNTMyNiAxNi40OTExIDE3LjEwODcgMTYuNjY2NyAxNi42NjY2IDE2LjY2NjdIMy4zMzMyOUMyLjg5MTI3IDE2LjY2NjcgMi40NjczNCAxNi40OTExIDIuMTU0NzggMTYuMTc4NkMxLjg0MjIyIDE1Ljg2NiAxLjY2NjYzIDE1LjQ0MjEgMS42NjY2MyAxNVY1LjAwMDA0WiIgc3Ryb2tlPSIjMDA5QkJGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS42NjY2MyA2LjY2Njc1TDcuOTE3NDYgMTEuNjY3NkM4LjUwODUzIDEyLjE0MDUgOS4yNDI5NyAxMi4zOTgyIDkuOTk5OTYgMTIuMzk4MkMxMC43NTY5IDEyLjM5ODIgMTEuNDkxNCAxMi4xNDA1IDEyLjA4MjUgMTEuNjY3NkwxOC4zMzMzIDYuNjY2NzUiIHN0cm9rZT0iIzAwOUJCRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==";
export { SvgMail as ReactComponent };